module.exports = __webpack_public_path__ + "static/media/stepper-collaborate-active.d3751ca1.svg";